import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";

export const fetchSalesReturnGSTR1 = createAsyncThunk(
  "salesReturnGSTR1/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await postData("/reports/get-gstr1-summary", filters);

   
      if (!res || !res.data) {
        return [];
      }

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message || "API Error"
      );
    }
  }
);